
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/repurpose-content",
      function () {
        return require("private-next-pages/repurpose-content.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/repurpose-content"])
      });
    }
  